import FormValidator from '../../../../helper/formValidator';

const validator = new FormValidator([
  {
    field: 'firstName',
    method: 'isEmpty',
    validWhen: false,
    message: 'اجباری است'
  },
  {
    field: 'lastName',
    method: 'isEmpty',
    validWhen: false,
    message: 'اجباری است'
  },
  {
    field: 'mobileNumber',
    method: 'isEmpty',
    validWhen: false,
    message: 'اجباری است'
  },
  {
    field: 'mobileNumber',
    method: 'isEmpty',
    validWhen: false,
    message: 'اجباری است'
  },
  {
    field: 'mobileNumber',
    validWhen: true,
    message: 'باید 11 کاراکتر باشد',
    method: (value) => {
      return value.length === 11;
    }
  },
  {
    field: 'state',
    method: 'isEmpty',
    validWhen: false,
    message: 'اجباری است'
  },
  {
    field: 'region',
    method: 'isEmpty',
    validWhen: false,
    message: 'اجباری است'
  },
  {
    field: 'transactionType',
    method: 'isEmpty',
    validWhen: false,
    message: 'اجباری است'
  },
  {
    field: 'propertyType',
    method: 'isEmpty',
    validWhen: false,
    message: 'اجباری است'
  },
]);

export default validator;
